module.exports = __webpack_public_path__ + "assets/956c8fa7ea844f1fb4a5d6f753d3ebe0.png";